import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const editBranchDetailsClient = async (reqBody) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.updatePostalCodeByBranch()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reqBody),
    });

    if (!res.ok) {
        return { error: true, message: 'Postal code update by branch request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default editBranchDetailsClient;
